module.exports = __webpack_public_path__ + "img/share.0fd31747.svg";